import { VideoResult } from "common/video/dto/VideoResult";
import styled from "styled-components";
import { staticContentPath } from "common/static_content_common";
import VideoPlay from "components/common/video/VideoPlay";

type VideoItemProps = {
  video: VideoResult;
};

const VideoItem = ({ video }: VideoItemProps) => {
  return (
    <Div>
      {video.fileName && (
        <VideoPlay
          filePath={staticContentPath(video.fileName)}
          autoPlay={true}
          muted={true}
          width={400}
          loop
        />
      )}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  margin-top: 2rem;
  margin-left: 2rem;
`;

export default VideoItem;
